import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ButtonComponent, IconComponent, TooltipDirective } from '@mode/capra';
import { FeatureFlag, FeatureFlagsFacade } from '@mode/shared/contract-common';
import { ReportSchedule } from '@mode/shared/schedules/contract';
import { ScheduleSummaryPipe } from '@mode/shared/schedules/ui';
import { Observable } from 'rxjs';

@Component({
  standalone: true,
  imports: [CommonModule, ButtonComponent, IconComponent, ScheduleSummaryPipe, TooltipDirective],
  selector: 'mode-schedule-list-description-tile',
  templateUrl: './schedule-list-description-tile.component.html',
  styleUrls: ['./schedule-list-description-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScheduleListDescriptionTileComponent implements OnInit {
  @Input({ required: true }) schedule!: ReportSchedule;
  @Input() reportType = 'Report';
  showNamedSchedules$: Observable<boolean> | undefined;
  adminManagedScheduleIntervals$: Observable<boolean> | undefined;
  constructor(private featureFlagsFacade: FeatureFlagsFacade) {}

  ngOnInit(): void {
    this.showNamedSchedules$ = this.featureFlagsFacade.asObservable(FeatureFlag.ShowNamedSchedules);
    this.adminManagedScheduleIntervals$ = this.featureFlagsFacade.asObservable(
      FeatureFlag.AdminManagedScheduleIntervals
    );
  }
}
